const phoneCountries = [
  {
    code: "+502",
    country: "Guatemala",
    iso: "GT",
    flag: "🇬🇹",
    minLength: 8,
    maxLength: 8
  },
  {
    code: "+1",
    country: "United States",
    iso: "US",
    flag: "🇺🇸",
    minLength: 10,
    maxLength: 10
  },
  {
    code: "+34",
    country: "Spain",
    iso: "ES",
    flag: "🇪🇸",
    minLength: 9,
    maxLength: 9
  },
  {
    code: "+52",
    country: "Mexico",
    iso: "MX",
    flag: "🇲🇽",
    minLength: 10,
    maxLength: 10
  },
  {
    code: "+57",
    country: "Colombia",
    iso: "CO",
    flag: "🇨🇴",
    minLength: 10,
    maxLength: 10
  }
];

export default phoneCountries;
